module.exports = "/dist/img/noshi07.dddee886.jpg";